import { createContext, FC, ReactNode, useContext, useMemo, useState } from "react";

interface CampaignLifeCycleChoiceContextValue {
  replacesTicketingId: string | null;
  setReplacesTicketingId: (replacesTicketingId: string | null) => void;
}

const CampaignLifeCycleChoiceContext = createContext<CampaignLifeCycleChoiceContextValue>({
  replacesTicketingId: null,
  setReplacesTicketingId: () => undefined,
});

export const CampaignLifeCycleChoiceProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [replacesTicketingId, setReplacesTicketingId] = useState<string | null>(null);
  const value = useMemo(() => ({ replacesTicketingId, setReplacesTicketingId }), [replacesTicketingId]);

  return <CampaignLifeCycleChoiceContext.Provider value={value}>{children}</CampaignLifeCycleChoiceContext.Provider>;
};

export const useCampaignLifeCycleChoiceContext = () => useContext(CampaignLifeCycleChoiceContext);
